import { AppConfig } from '@dh-io-emh/config-types';
import { createHttpService } from '../utils/http.util';
import { Logger } from '../utils/logger.util';
import { DCPCarProductEquipmentDTO } from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';

interface VDSVehicleData {
  vehicleData: {
    equipments: (Required<DCPCarProductEquipmentDTO> & { visibility?: boolean; name: Record<string, string> })[];
  };
}

export type VdsApi = ReturnType<typeof createVDSApi>;

export const createVDSApi = ({ config: { bosVdsApiUrl, lang } }: { config: AppConfig }) => {
  const http = createHttpService({
    url: `${bosVdsApiUrl}/vehicle`,
    params: { lang },
  });

  return {
    async getVehicleEquipments(commissionNumber: string, lng: string): Promise<DCPCarProductEquipmentDTO[]> {
      try {
        const { data } = await http.get<{ data: VDSVehicleData }>(commissionNumber);

        return data.data.vehicleData.equipments
          .filter((equipment) => equipment.visibility)
          .map(
            (equipment) =>
              ({
                code: equipment.code,
                pack: equipment.pack,
                parentPack: equipment.parentPack,
                name: equipment.name[lng.toLowerCase()],
              } as DCPCarProductEquipmentDTO),
          );
      } catch (error) {
        Logger.error('vdsApi::getVehicleEquipments()', error);

        return [];
      }
    },
  };
};
